import React, { JSX, useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import SEO from 'components/seo';
import { Box, Container, VStack, Text, Heading } from '@chakra-ui/react';
import { ROUTES } from 'services/shared/routerService';
import { isNativePlatform } from 'services/shared/clientService';
import HeroSection from 'components/heroSection';
import HeroVisual, { DEFAULT_HERO_VISUAL_ITEMS } from 'components/heroVisual';
import SEOCopySection from 'components/seoCopySection';
import FAQSection from 'components/faqSection';
import MosaicGrid from 'components/mosaicGrid';
import Section from 'components/section';
import PromptSection from 'components/promptSection';
import CloudStorageSection from 'components/cloudStorageSection';
import WorkflowSection from 'components/workflowSection';

const Testimonials = dynamic(() => import('components/testimonialsSection'), { ssr: false });
const PricingSection = dynamic(() => import('components/pricingSection'), { ssr: false });
const JoinSection = dynamic(() => import('components/joinSection'), { ssr: false });

function Home(): JSX.Element {
	const [shouldLoad, setShouldLoad] = useState(false);

	useEffect(() => {
		setShouldLoad(true);
	}, []);

	return (
		<Box bg="white">
			<SEO
				title="Imagemotion: AI Image & Video Production Platform"
				description="Create stunning images and videos with our AI production platform. Your AI image & video production studio for creators and brands. Try for free!"
			/>

			<Container maxWidth={'5xl'} id={'Prompt'}>
				<Section mt={32} mb={20}>
					<PromptSection />
				</Section>
			</Container>

			<HeroSection
				copy={`New • Seedance 2.0 • Realistic Videos`}
				title={`**AI Media Tools for** \n Image and Video Production`}
				subtitle={`Imagemotion — Your all-in-one AI platform for Image and Video Production. Enhance your creative workflow with powerful, cutting-edge AI tools.`}
				ctaPrimary={{ text: 'Start creating now — Free', href: ROUTES.REGISTER }}
				content={<HeroVisual items={DEFAULT_HERO_VISUAL_ITEMS} />}
			/>

			{/*<LogoCloud />*/}

			{/*<CustomerAdsGrid />*/}

			<MosaicGrid />

			{/*<ModelShowCaseSection />*/}

			<CloudStorageSection />

			<WorkflowSection />

			{/*<StepsSection />*/}

			{/*<FeatureShowcase*/}
			{/*	rows={[*/}
			{/*		{*/}
			{/*			eyebrow: 'The Studio',*/}
			{/*			title: (*/}
			{/*				<>*/}
			{/*					A studio crew,{' '}*/}
			{/*					<Box as="span" color={'gray.500'}>*/}
			{/*						in your browser.*/}
			{/*					</Box>*/}
			{/*				</>*/}
			{/*			),*/}
			{/*			body: 'Direction, art, lighting, retouching and color — imagemotion replaces a 12-person production team with a single prompt. The output is indistinguishable from a six-figure shoot. Generate photorealistic image ads using our AI advertisement generator from any product photo',*/}
			{/*			bullets: ['Photoreal subject preservation', 'Brand-locked aesthetics, every render'],*/}
			{/*			image: AD.TREE_LAMP,*/}
			{/*			alt: 'Minimalist studio with product on pedestal — imagemotion interface',*/}
			{/*			imageRight: true,*/}
			{/*		},*/}
			{/*		// {*/}
			{/*		// 	eyebrow: 'Cinematic Video',*/}
			{/*		// 	title: (*/}
			{/*		// 		<>*/}
			{/*		// 			Super Bowl spots,{' '}*/}
			{/*		// 			<Box as="span" color={'gray.500'}>*/}
			{/*		// 				in 60 seconds.*/}
			{/*		// 			</Box>*/}
			{/*		// 		</>*/}
			{/*		// 	),*/}
			{/*		// 	body: 'Turn any prompt into scroll-stopping AI video ads using our powerful AI ads generator. Place your product in unlimited locations — a beach in Bali, a street in NYC, or a luxury studio — and generate ad creatives instantly.',*/}
			{/*		// 	bullets: [],*/}
			{/*		// 	image: AD.WATCH_AD_VIDEO ? AD.WATCH_AD : AD.WATCH_AD,*/}
			{/*		// 	alt: 'Cinematic watch ad — example of imagemotion video output',*/}
			{/*		// },*/}
			{/*		// {*/}
			{/*		// 	eyebrow: 'Iteration',*/}
			{/*		// 	title: (*/}
			{/*		// 		<>*/}
			{/*		// 			500 variations{' '}*/}
			{/*		// 			<Box as="span" color={'gray.500'}>*/}
			{/*		// 				before lunch.*/}
			{/*		// 			</Box>*/}
			{/*		// 		</>*/}
			{/*		// 	),*/}
			{/*		// 	body: 'A/B-test angles, models, scenes and copy. Export your creatives in one click for TikTok, Instagram, Facebook and YouTube. Launch campaigns faster with an all-in-one AI ad maker built for performance marketing.',*/}
			{/*		// 	bullets: ['TikTok, Instagram, Instagram, YouTube', 'Native 9:16, 1:1, 16:9', 'H.264'],*/}
			{/*		// 	image: AD.CHAIN_AD2,*/}
			{/*		// 	alt: 'Editorial ad variant created by imagemotion',*/}
			{/*		// 	imageRight: true,*/}
			{/*		// },*/}
			{/*	]}*/}
			{/*/>*/}

			{/*{!isNativePlatform() && <Testimonials />}*/}

			{!isNativePlatform() && (
				<Box py={32} bg={'realWhite'} border={1}>
					<Container maxW="6xl">
						<VStack textAlign="center" gap={0}>
							<Text
								fontSize="11px"
								fontWeight="500"
								textTransform="uppercase"
								letterSpacing="0.22em"
								color="gray.400"
							>
								Pricing
							</Text>
							<Heading
								mt={5}
								mb={8}
								maxW="2xl"
								fontSize={{ base: '2.25rem', md: '3.75rem' }}
								fontWeight={400}
								lineHeight={1}
								letterSpacing="-0.035em"
							>
								Explore Limitless Creativity
							</Heading>
							{/*<Box*/}
							{/*	bgGradient="to-r"*/}
							{/*	gradientFrom="red.500"*/}
							{/*	gradientTo="orange.400"*/}
							{/*	color="white"*/}
							{/*	px={6}*/}
							{/*	py={2}*/}
							{/*	borderRadius="full"*/}
							{/*	fontWeight="900"*/}
							{/*	fontSize="lg"*/}
							{/*	shadow="0 4px 15px rgba(239, 68, 68, 0.4)"*/}
							{/*	letterSpacing="wider"*/}
							{/*	textTransform="uppercase"*/}
							{/*	transform="rotate(-1deg)"*/}
							{/*	mb={10}*/}
							{/*	_hover={{ transform: 'rotate(0deg) scale(1.05)', transition: 'all 0.2s' }}*/}
							{/*>*/}
							{/*	60% OFF SUMMER SALE*/}
							{/*</Box>*/}
						</VStack>
						<PricingSection />
					</Container>
				</Box>
			)}

			{/*<FinalCtaSection />*/}

			<SEOCopySection />

			{!isNativePlatform() && (
				<FAQSection
					faqs={[
						{
							question: 'What is Imagemotion Creative Studio?',
							answer: 'magemotion Creative Studio is an all-in-one platform offering AI-powered tools for image and video production, including ai text to image generation, ai text to video generation and more. Using the latest AI generation models.',
						},
						{
							question: 'Can I use the products for free?',
							answer: 'Imagemotion Creative Studio offers a free plan, and you occasionally receive free credits. However, our advanced features require payment.',
						},
						{
							question: 'Is Imagemotion AI suitable for professional creators?\n',
							answer: 'Yes, our platform is designed for artists, designers, marketers, and anyone looking to be creative with advanced AI tools.',
						},
						{
							question: 'Can I export the projects I create?\n',
							answer: 'Yes, you can easily export your projects using the download button. Videos are exported in MP4 format. You will always receive the highest resolution available.',
						},
						{
							question: 'Do I need to have design or video editing experience to use the ai tools?',
							answer: 'No, you don’t need any design or video editing experience — our AI tools are easy to use and built for everyone.',
						},
						{
							question: 'Can I use the content I create for commercial use?\n',
							answer: 'Yes, you can use the content you create with Imagemotion Creative Studio for commercial purposes.',
						},
						{
							question: 'What AI models are available?\n',
							answer: 'Nano Banana (Gemini 2.5) for image generation and Bytedance (Seedance 2.0) for video generation.',
						},
						{
							question: 'Is there a monthly fee for this AI ads generator?',
							answer: "No. Imagemotion uses a transparent 'pay-as-you-go' credit system. You buy credits when you need them for our AI ad generator, and they never expire. No hidden fees or recurring bills.",
						},
					]}
				/>
			)}
		</Box>
	);
}

export default Home;
